import React, {Context, createContext, useContext, useEffect, useState} from "react";
import {getZXingWASM, loadZXingLib} from "@lib/zxing";
import {useNavigate} from "react-router-dom";
import useIsLoggedIn from "@hooks/useIsLoggedIn";
import {Spin} from "antd";
import {showHideLoadingOverlay} from "@lib/showHideLoadingOverlay";

const BarcodeReadContext: Context<any> = createContext(['', Function, Function]);

export const useSearchBarcode = () => useContext(BarcodeReadContext)[1];
export const useShowIsScanning = () => useContext(BarcodeReadContext)[2];

const BarcodeReadProvider = ({children}) => {
    const [barcode, setBarcode] = useState("");
    const navigate = useNavigate();
    const isLoggedIn = useIsLoggedIn();
    const [showIsScanning, setShowIsScanning] = useState(false);

    useEffect(() => {
        const addCameraButtonToSearchNav = async () => {
            await loadZXingLib();
            const ZXingWASM = getZXingWASM();

            if(ZXingWASM && ZXingWASM.readBarcodesFromImageFile){
                //if library successfully added. Do something.
            }
        };

        window.addEventListener('load', addCameraButtonToSearchNav, false);
    }, []);

    useEffect(() => {
        if(barcode && barcode !== ''){
            setShowIsScanning(true);
            window.location.href = '/search?search='+barcode;
        }
    }, [barcode]);

    useEffect(() => {
        showHideLoadingOverlay(showIsScanning);
    }, [showIsScanning]);

    return <BarcodeReadContext.Provider value={[barcode, setBarcode, setShowIsScanning]}>
        <div>
            {children}
        </div>
    </BarcodeReadContext.Provider>
};

export default BarcodeReadProvider;
